import React from "react";
import propTypes from "prop-types";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import Panel from "../Panel/Panel";
import Nav from "../Nav/Nav";
import MobileNav from "../MobileNav/MobileNav";

import * as constants from "../../data/constants";

import icons from "../../data/icons";
// import appData from '../../data/app.json';

import "./Group.css";

class Group extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playGif: true,
      propositionsEntered: 5,
      navEntered: 0
    };
    this.iconsDelay = 1000;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentGroup !== this.props.currentGroup) {
      this.setState({
        propositionsEntered: 5,
        navEntered: 0
      }); // stops propositions not entering when moving back
    }
  }

  handleIconTimings(nextProps) {
    let { navEntered /*, propositionsEntered, playGif*/ } = this.state;

    if (this.props.currentGroup === "Home") {
      this.setState({ propositionsEntered: 5, playGif: true });
    }

    if (!nextProps.navigationWait && nextProps.currentGroup !== "Home") {
      const interval = setInterval(() => {
        navEntered += 1;
        this.setState({
          navEntered
        });
        if (this.state.navEntered === 10) {
          clearInterval(interval);
        }
        if (nextProps.currentGroup !== this.props.currentGroup) {
          navEntered = 0;
          this.setState({
            navEntered
          });
          clearInterval(interval);
        }
      }, 250);
    }
    if (
      nextProps.currentGroup !== this.props.currentGroup &&
      nextProps.currentGroup !== "Home"
    ) {
      navEntered = 0;
      this.setState({
        navEntered
      });
    }
  }

  render() {
    return (
      <section
        className={`group ${this.props.data.gradient ? "gradiated" : ""}`}
        id={this.props.data.groupID}
      >
        <header className={"group__header"}>
          {this.props.data.title && !this.props.data.panelID && (
            <h1 className={"group__title"}>{this.props.data.title}</h1>
          )}
          <MediaQuery query={constants.removeOnMobile}>
            {/* {this.props.currentGroup === "Home" && ( */}
              <div
                className={`group__valuePropositions ${
                  this.state.playGif ? "entered" : ""
                }`}
              >
                {this.props.data.description && (
                  <span>{this.props.data.description}</span>
                )}
                {this.props.data.valuePropList && (
                  <span style={{ fontWeight: "bold" }}>Our solutions enable:</span>
                )}
                {this.props.data.valuePropList && (
                  <ul className={"valuePropositions__list"}>
                    <li
                      className={`valuePropositions__item ${
                        this.state.propositionsEntered > 0 ? "entered" : ""
                      }`}
                    >
                      <img
                        src={icons.saving.gif}
                        alt={"Space Saving icon"}
                        className={"valuePropositions__image"}
                      />
                      Project execution & standardization
                    </li>
                    <li
                      className={`valuePropositions__item ${
                        this.state.propositionsEntered > 1 ? "entered" : ""
                      }`}
                    >
                      <img
                        src={icons.flexibility.gif}
                        alt={"Modularity/Flexibility icon"}
                        className={"valuePropositions__image"}
                      />
                      Scalability & flexibility
                    </li>
                    <li
                      className={`valuePropositions__item ${
                        this.state.propositionsEntered > 2 ? "entered" : ""
                      }`}
                    >
                      <img
                        src={icons.operation.gif}
                        alt={"Continuous Operation icon"}
                        className={"valuePropositions__image"}
                      />
                      Continuous operations
                    </li>
                    <li
                      className={`valuePropositions__item ${
                        this.state.propositionsEntered > 3 ? "entered" : ""
                      } fourth`}
                    >
                      <img
                        src={icons.efficiency.gif}
                        alt={"Efficiency & Security icon"}
                        className={"valuePropositions__image"}
                      />
                      Efficiency & Safety
                    </li>
                  </ul>
                )}
              </div>
            {/* )} */}
          </MediaQuery>
        </header>
        <MediaQuery query={constants.addOnMobile}>
          <MobileNav data={this.props.data.nav} type={"group"} />
        </MediaQuery>
        <MediaQuery query={constants.removeOnMobile}>
          {this.props.data.nav && (
            <nav>
              {this.props.data.nav.map(
                (nav, i) =>
                  !nav.disabled && (
                    <Nav
                      key={`nav${this.props.groupID}-${nav.top}-${nav.left}`}
                      class={`${
                        this.state.navEntered > i ||
                        document.body.clientWidth < constants.tabletSize
                          ? "entered"
                          : ""
                      }`}
                      index={nav.index}
                      groupID={nav.groupID}
                      animation={nav.animation}
                      warn={nav.warn}
                      top={constants.hotspotTransform.transformTop(nav.top)}
                      left={constants.hotspotTransform.transformLeft(nav.left)}
                      type={nav.type}
                      title={nav.title}
                    />
                  )
              )}
            </nav>
          )}
        </MediaQuery>
        {this.props.data.panelID && <Panel panelID={this.props.data.panelID} />}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentGroup: state.navigation.currentGroup,
    appReady: state.media.appReady,
    navigationWait: state.navigation.navigationWait
  };
}

Group.propTypes = {
  data: propTypes.shape({
    title: propTypes.string.isRequired,
    groupID: propTypes.string.isRequired,
    subtitle: propTypes.string,
    nav: propTypes.array
  }),
  currentStage: propTypes.number,
  currentGroup: propTypes.string.isRequired,
  groupID: propTypes.string.isRequired,
  appReady: propTypes.bool.isRequired,
  navigationWait: propTypes.bool.isRequired
};

export default connect(mapStateToProps)(Group);
